import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer class="content-footer footer bg-footer-theme">
      <div class="container-xxl">
        <div class="footer-container d-flex align-items-center justify-content-between py-2 flex-md-row flex-column">
          <div>
            ©
            <script>document.write(new Date().getFullYear());</script>
            , made
            with ❤️ by {" "}
            <Link onClick={() => window.scrollTo({top:0 , behavior: 'smooth'})} to="#" className="footer-link text-primary fw-medium">
               Zenosure
            </Link>
          </div>
          <div class="d-none d-lg-inline-block">
            <Link className="footer-link me-4" to="/privacyPolicy" target="blank" >
            Privacy Policy
            </Link>
            <Link to="/termsConditions" target="blank" class="footer-link me-4">
            Terms And Conditions
            </Link>

            {/* <Link to="#" class="footer-link me-4">
              Documentation
            </Link>

            <Link to="#" class="footer-link d-none d-sm-inline-block">
              Support
            </Link> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
